// TerminosCondiciones.jsx
import React, { useEffect } from "react";
import { Container, Typography, Divider, Box, Link } from "@mui/material";
import logo from "../../Recursos/logo.svg"; // 👈 importa tu logo

export default function TerminosCondiciones() {
    useEffect(() => {
        // SEO: title
        document.title = "Términos y Condiciones - EspacioCompacto";

        // SEO: meta description
        const meta = document.querySelector('meta[name="description"]');
        const description =
            "Términos y condiciones de uso del sitio web de EspacioCompacto (remodelación de cocinas, baños y closets en Cali).";
        if (meta) {
            meta.setAttribute("content", description);
        } else {
            const m = document.createElement("meta");
            m.name = "description";
            m.content = description;
            document.head.appendChild(m);
        }

        // JSON-LD (WebSite)
        const jsonLd = {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "EspacioCompacto",
            url: "https://espaciocompacto.com",
            publisher: {
                "@type": "Organization",
                name: "EspacioCompacto",
            },
        };
        const scriptId = "jsonld-terminos-condiciones";
        let script = document.getElementById(scriptId);
        if (script) script.remove();
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = scriptId;
        script.text = JSON.stringify(jsonLd);
        document.head.appendChild(script);

        return () => {
            const s = document.getElementById(scriptId);
            if (s) s.remove();
        };
    }, []);

    return (
        <Container maxWidth="md" sx={{ py: 6, pt: 16 }}>
            {/* 🔹 Logo arriba */}
            <Box sx={{ textAlign: "center", mb: 4 }}>
                <Box
                    component="img"
                    src={logo}
                    alt="Logo EspacioCompacto"
                    sx={{ width: 150, height: "auto" }}
                />
            </Box>

            <Typography variant="h4" component="h1" gutterBottom>
                Términos y Condiciones
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                EspacioCompacto — Remodelación de cocinas, baños y closets (Cali, Colombia)
            </Typography>
            <Divider sx={{ my: 2 }} />

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">1. Aceptación de los términos</Typography>
                <Typography paragraph>
                    El acceso y uso del sitio https://espaciocompacto.com implica la aceptación plena de estos Términos y Condiciones. Si no estás de acuerdo, por favor no uses este sitio.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">2. Objeto</Typography>
                <Typography paragraph>
                    Estos términos regulan el uso del sitio web y la contratación de servicios de <strong>EspacioCompacto</strong> relacionados con la remodelación y diseño de cocinas, baños y closets en Cali. Este sitio no realiza ventas online ni gestiona pagos por comercio electrónico.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">3. Acceso y uso del sitio</Typography>
                <Typography paragraph>
                    El usuario se compromete a utilizar el sitio conforme a la ley, estos términos y la buena fe. Está prohibido introducir contenido ilegal, dar un uso indebido o intentar vulnerar la seguridad del sitio.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">4. Propiedad intelectual</Typography>
                <Typography paragraph>
                    Todos los contenidos (textos, imágenes, diseños, marcas, logotipos) son titularidad de EspacioCompacto o de terceros colaboradores. Queda prohibida su reproducción total o parcial sin autorización expresa.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">5. Formularios y comunicaciones</Typography>
                <Typography paragraph>
                    Los formularios de contacto permiten a los usuarios enviar su información (nombre, apellido, celular, correo y mensaje) para solicitar información y presupuestos. Al enviar un formulario, autorizas el tratamiento de tus datos conforme a la{" "}
                    <Link href="/politica-privacidad/">Política de Privacidad</Link>.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">6. Limitación de responsabilidad</Typography>
                <Typography paragraph>
                    EspacioCompacto no se responsabiliza por daños derivados del uso inadecuado del sitio, errores en la información proporcionada por terceros o por causas fuera de nuestro control. La información del sitio se ofrece "tal cual" y puede contener inexactitudes.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">7. Protección de datos</Typography>
                <Typography paragraph>
                    El tratamiento de datos personales recogidos a través del sitio se rige por la{" "}
                    <Link href="/politica-privacidad/">Política de Privacidad</Link>. Para ejercitar derechos de acceso, rectificación o supresión, contacta:{" "}
                    <Link href="mailto:info@Martha.com">info@Martha.com</Link>.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">8. Enlaces a sitios de terceros</Typography>
                <Typography paragraph>
                    El sitio puede contener enlaces a webs externas que no están bajo nuestro control. No nos hacemos responsables por el contenido o las prácticas de privacidad de dichos sitios.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">9. Modificación de los términos</Typography>
                <Typography paragraph>
                    Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Publicaremos la versión actualizada en esta misma sección con la fecha de revisión.
                </Typography>
            </Box>

            <Box component="section" sx={{ mb: 3 }}>
                <Typography variant="h6">10. Legislación aplicable y jurisdicción</Typography>
                <Typography paragraph>
                    Estos términos se rigen por la legislación colombiana. Para cualquier controversia será competente la jurisdicción ordinaria del domicilio del proveedor o, si así se acuerda, los tribunales competentes conforme a la ley.
                </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Typography variant="body2" color="text.secondary" paragraph>
                Última actualización: {new Date().toLocaleDateString()}.
            </Typography>

            <Box sx={{ mt: 4, p: 2, bgcolor: "background.paper", borderRadius: 1 }}>
                <Typography variant="subtitle2">Aviso:</Typography>
                <Typography variant="body2">
                    Este documento es informativo y está adaptado a la información proporcionada. No sustituye el asesoramiento jurídico profesional. Para condiciones contractuales específicas o documentos legales firmables, consulte con un abogado.
                </Typography>
            </Box>
        </Container>
    );
}
